export class Rename {
    id: string;
    name: string;
    constructor( id,name){
        this.id =  id;
        this.name =  name;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/rename/rename.ts